import { proxy } from "@/util/proxy.mjs";

interface WalletRefs {
  ProTile: React.FC;
  fetchFunctions: Array<() => void>;
  currencies: Array<React.FC>;
}

export const walletRefs = proxy<WalletRefs>({
  ProTile: () => null,
  fetchFunctions: [],
  currencies: [],
});
